import { render, staticRenderFns } from "./VideoDialog2.vue?vue&type=template&id=8a9d7024&scoped=true"
import script from "./VideoDialog2.vue?vue&type=script&lang=js"
export * from "./VideoDialog2.vue?vue&type=script&lang=js"
import style0 from "./VideoDialog2.vue?vue&type=style&index=0&id=8a9d7024&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9d7024",
  null
  
)

export default component.exports